import CalendarIcon from "../../icons/calendarIcon";
import GraphLineIcon from "../../icons/graphLineIcon";
import TwoUsersIcon from "../../icons/twoUsersIcon";
import UserRemoveIcon from "../../icons/userRemoveIcon";
import WorkHistoryIcon from "../../icons/workHistoryIcon";

const Cards = ({ t }) => {
  const cards = [
    {
      title: t("totalMembers"),
      number: "1,234",
      icon: TwoUsersIcon,
      statIcon: GraphLineIcon,
    },
    {
      title: t("todayBookings"),
      number: "48",
      icon: CalendarIcon,
      statIcon: GraphLineIcon,
    },
    {
      title: t("storeRequests"),
      number: "23",
      icon: CalendarIcon,
      statIcon: GraphLineIcon,
    },
    { title: t("activeEmployees"), number: "18", icon: WorkHistoryIcon, statIcon: "" },
    {
      title: t("expiringMemberships"),
      number: "14",
      icon: UserRemoveIcon,
      statIcon: "",
    },
  ];
  return (
    <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
      {cards.map((card, i) => {
        const StatsIcon = card?.statIcon ? card.statIcon : () => null;
        const Icon = card.icon;
        return (
          <div
            key={i}
            className="border-[#D1A8551A] border flex items-start justify-between gap-4 rounded-2xl p-6 lg:p-4 shadow-md mainLinear"
          >
            <div>
              <h3 className="mb-3 text-sm lg:max-w-[101px] font-medium text-mainGray">
                {card.title}
              </h3>
              <p className="my-2 text-2xl font-bold">{card.number}</p>
              <div className="rtl:mr-auto ltr:ml-auto w-fit">
                <StatsIcon />
              </div>
            </div>
            <span className="grid rounded-full bg-mainBg place-content-center size-11">
              <Icon />
            </span>
          </div>
        );
      })}
    </section>
  );
};

export default Cards;
